import { render, staticRenderFns } from "./PostSection6.vue?vue&type=template&id=5abaed84&scoped=true"
import script from "./PostSection6.vue?vue&type=script&lang=js"
export * from "./PostSection6.vue?vue&type=script&lang=js"
import style0 from "./PostSection6.vue?vue&type=style&index=0&id=5abaed84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abaed84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5abaed84')) {
      api.createRecord('5abaed84', component.options)
    } else {
      api.reload('5abaed84', component.options)
    }
    module.hot.accept("./PostSection6.vue?vue&type=template&id=5abaed84&scoped=true", function () {
      api.rerender('5abaed84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blog/PostSection6.vue"
export default component.exports